import { Avatar, Tooltip } from "@mui/material";
type Props = {};

const AppLogo = ({
  showLinkIconsOnly = false,
}: {
  showLinkIconsOnly?: boolean;
}) => {
  return (
    <Tooltip title={process.env.REACT_APP_VERSION}>
      <Avatar
        sx={{
          width: showLinkIconsOnly ? 50 : 150,
          height: showLinkIconsOnly ? 50 : 150,
          mx: "auto",
          filter: "drop-shadow(0px 4px 20px #0000001a)",
          color: "primary.main",
        }}
        variant="circular"
        src="/images/logo.svg"
        alt="company logo"
      />
    </Tooltip>
  );
};

export default AppLogo;
